import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import {YN} from "../../components/AppConstants";

export default {
  state: {
    surveys: [],
    selectSurvey: null,
    surveyAnswerYn: YN.N,
    validateYn: YN.N,
    surveyQuestions: [],
    selectGuestSurvey : null,
  },
  getters,
  mutations,
  actions
}





// WEBPACK FOOTER //
// ./src/store/survey/index.js